import { Brand } from '../types';

export const brands2: Array<Brand> = [
	{ code: '5597488105896580', name: 'Adidas', image: 'Adidas.webp' },
	{ code: '5065409710886', name: 'Lacoste', image: 'Lacoste.webp' },
	{ code: '3278970575752240', name: 'Levis', image: 'Levis.webp' },
	{ code: '6235228668790880', name: 'Mango', image: 'Mango.webp' },
	{ code: '1705188002013680', name: 'Zara', image: 'Zara.webp' },
];